import { RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { ToastModule } from "primeng/toast";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
  // MessageService is provided at the application root (app.config.ts) so this always-present
  // <p-toast> shares the same instance the HTTP interceptors use (e.g. the 403 handler).
})
export class AppComponent {

  }